import {
	UserAdjustmentAction,
	UserAdjustmentStatus,
	BillingTotals,
	dateOrNull,
} from "../../../index";

type UserAdjustmentProps = {
	internalId: string;
	externalId: string;
	transactionId: string;
	subscriptionId: string;
	action: UserAdjustmentAction;
	status: UserAdjustmentStatus;
	createdAt: Date | null;
	reason: string;
	totals?: BillingTotals;
};

class UserAdjustment {
	constructor(public _: UserAdjustmentProps) {}

	static fromFirestore(userAdjustment: any) {
		const data = userAdjustment.data();
		return new UserAdjustment({
			internalId: userAdjustment.id,
			externalId: data.data.id,
			transactionId: data.data.transaction_id,
			subscriptionId: data.data.subscription_id,
			action: data.data.action,
			status: data.data.status,
			createdAt: dateOrNull(data.created_at),
			reason: data.data.reason,
			totals: data.data.totals ? BillingTotals.fromJson(data.data.totals) : undefined,
		});
	}

	static fromJson(data: any) {
		return new UserAdjustment({
			internalId: data.internal_id,
			externalId: data.external_id,
			transactionId: data.transaction_id,
			subscriptionId: data.subscription_id,
			action: data.action,
			status: data.status,
			createdAt: dateOrNull(data.created_at),
			reason: data.reason,
			totals: data.totals ? BillingTotals.fromJson(data.totals) : undefined,
		});
	}

	toJson() {
		return {
			internal_id: this._.internalId,
			external_id: this._.externalId,
			transaction_id: this._.transactionId,
			subscription_id: this._.subscriptionId,
			action: this._.action,
			status: this._.status,
			created_at: this._.createdAt,
			reason: this._.reason,
			totals: this._.totals?.toJson(),
		};
	}
}

export { UserAdjustment };
